export const DocumentType = [
    {
        id: "CC",
        text: "Cédula ciudadania",
    },
    {
        id: "TI",
        text: "Tarjeta identidad",
    },
    {
        id: "CE",
        text: "Cédula extranjeria",
    },
    {
        id: "PTP",
        text: "Permiso temporal",
    },
    {
        id: "RC",
        text: "Registro civil",
    },
    {
        id: "PE",
        text: "Permiso especial PEP",
    },
    {
        id: "RUT",
        text: "Registro único tributario",
    },
    {
        id: "PA",
        text: "Pasaporte",
    },
    {
        id: "SC",
        text: "Salvoconducto",
    },
    {
        id: "CD",
        text: "Carnet diplomatico",
    },
]